const HTTP = 'http:';
const HTTPS = 'https:';
const FIVERR_DOMAIN = 'fiverr.com';

module.exports = {
    HTTP,
    HTTPS,
    FIVERR_DOMAIN
};
